(() => {
  if (window.DekrafCartGuard) return;
  const element = document.getElementById('DekrafCartGuardConfig');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  const base = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  const bundleIds = new Set(config.bundleVariants.map(String));
  const pdfId = String(config.pdfVariant);
  let pending = Promise.resolve();
  let navigating = false;
  const serial = task => {
    const result = pending.then(task, task);
    pending = result.catch(() => {});
    return result;
  };
  const notice = (message, failed = false) => {
    let banner = document.getElementById('DekrafCartGuardNotice');
    if (!banner) {
      banner = document.createElement('p');
      banner.id = 'DekrafCartGuardNotice';
      banner.className = 'cart-guard-notice';
      const main = document.getElementById('MainContent') || document.body;
      main.prepend(banner);
    }
    banner.setAttribute('role', failed ? 'alert' : 'status');
    banner.textContent = message;
  };
  const jsonRequest = async (path, options = {}) => {
    const response = await nativeFetch(base + path, {
      credentials: 'same-origin',
      cache: 'no-store',
      ...options,
      headers: { Accept: 'application/json', ...options.headers }
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || config.error);
    return result;
  };
  const hasBundle = cart => cart.items.some(item => bundleIds.has(String(item.variant_id)));
  const normalize = async () => {
    let cart = await jsonRequest('cart.js');
    if (!hasBundle(cart)) return cart;
    const duplicates = cart.items.filter(item => String(item.variant_id) === pdfId);
    if (!duplicates.length) return cart;
    cart = await jsonRequest('cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: Object.fromEntries(duplicates.map(item => [item.key, 0])) })
    });
    if (cart.items.some(item => String(item.variant_id) === pdfId)) throw new Error(config.error);
    notice(config.included);
    document.dispatchEvent(new CustomEvent('dekraf:cart-normalized', { detail: { cart } }));
    return cart;
  };
  const add = body => serial(async () => {
    const cart = await normalize();
    if (String(body.get('id')) === pdfId && hasBundle(cart)) {
      notice(config.included);
      return new Response(JSON.stringify({ already_included: true }), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    }
    const response = await nativeFetch(base + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body,
      headers: { Accept: 'application/json' }
    });
    if (response.ok) await normalize();
    return response;
  });
  const checkout = async () => {
    if (navigating) return;
    navigating = true;
    try {
      await serial(normalize);
      window.location.assign(base + 'checkout');
    } catch (error) {
      navigating = false;
      notice(config.error, true);
    }
  };
  window.DekrafCartGuard = { add, normalize: () => serial(normalize), checkout };
  document.addEventListener('submit', event => {
    const form = event.target;
    const action = new URL(form.action || window.location.href, window.location.href);
    const isCheckout = action.origin === window.location.origin && /\/checkout\/?$/.test(action.pathname);
    const checkoutButton = event.submitter?.name === 'checkout';
    if (!isCheckout && !checkoutButton) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout();
  }, true);
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout();
  }, true);
})();
